module.exports = __webpack_public_path__ + "static/media/bar_default.8bfee405.jpg";